export default "__VITE_ASSET__BVTR_QIw__"